import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";
import ApiConstants from "../../Constants/ApiConstant";

export const getProductMetalDetailsAPI = (params, callBack) => {
  return async () => {
    try {
      let url = ApiConstants.productMetalUrl;
      const queryParams = [];

      if (params?.searchQuery)
        queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
      if (params.page)
        queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit)
        queryParams.push(`limit=${encodeURIComponent(params.limit)}`);

      // Append query parameters to URL if they exist
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const addProductMetalDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.productMetalUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add product metal api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add product metal api err:", err);
      throw err;
    }
  };
};

export const updateProductMetalDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.productMetalUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update product metal api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update product metal api err:", err);
      throw err;
    }
  };
};

export const deleteProductMetalDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiDelete(
        `${ApiConstants.productMetalUrl}/?product_metal_id=${data}`
      )
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("delete product metal api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("delete product metal api err:", err);
      throw err;
    }
  };
};

export const getMetalColorAPI = (params, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.getMetalColorUrl}`)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get metal color api err:", err);
          throw err;
        });
    } catch (error) {
      console.log("get metal color api err:", error);
      throw error;
    }
  };
};
